import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import { ForPaintSoftwareProjectSidebar as AsyncForPaintSidebarNextGen } from '@atlassian/jira-navigation-apps-sidebar-next-gen/src/async.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { createLayout } from '@atlassian/jira-route-layout/src/GlobalComponent.tsx';
import { issueNavigatorProjectSoftwareRoute } from '@atlassian/jira-router-routes-issue-navigator-routes/src/issueNavigatorProjectSoftwareRoute.tsx';
import { ProjectIssueNavigatorSkeleton } from '@atlassian/jira-skeletons/src/ui/issue-navigator/components/project-app.tsx';
import { AsyncHorizontalNavJira } from '@atlassian/jira-horizontal-nav/src/async.tsx';
import { softwareProjectLayoutNoOnboarding } from '@atlassian/jira-software-project-layout/src/index.tsx';
import { NIN_NEW_ISSUE_NAVIGATOR } from '@atlassian/jira-capabilities/src/constants.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { getCommonProjectResources } from './common/getCommonProjectResources.tsx';
import { getRouteReporting } from './common/getRouteReporting.tsx';
import { getSsrCircuitBreaker } from './common/getSsrCircuitBreaker.tsx';
import { issueNavigatorPageEntryPoint } from './ui/index.tsx';
import { ListRedirect } from './ui/list-redirect/ListRedirect.tsx';

/**
 * Software Project Issue Navigator Route Entry
 * Handles Software projects.
 */
export const issueNavigatorProjectSoftwareRouteEntry = createEntry(
	issueNavigatorProjectSoftwareRoute,
	() => ({
		group: 'issue-navigator',
		meta: {
			capability: NIN_NEW_ISSUE_NAVIGATOR,
			reporting: getRouteReporting(),
		},
		skeleton: ProjectIssueNavigatorSkeleton,
		navigation: {
			menuId: MENU_ID.PROJECTS,
			sidebar: AsyncForPaintSidebarNextGen,
			horizontal: AsyncHorizontalNavJira,
		},
		resources: [...getCommonProjectResources()],
		layout: createLayout(softwareProjectLayoutNoOnboarding),
		bifrost: {
			bifrostGroup: 'issue-navigator',
			bundling: {
				packageName:
					'@atlassian/jira-router-routes-issue-navigator-entries/src/issueNavigatorProjectSoftwareRouteEntry.tsx',
				whichExportToUse: 'issueNavigatorProjectSoftwareRouteEntry',
			},
			manifestName: 'jira-spa-issue-navigator.json',
			enabled: true,
			circuitBreakerConfig: getSsrCircuitBreaker(),
		},
		component: fg('jira_list_nin_merge') ? ListRedirect : undefined,
		entryPoint: () => (fg('jira_list_nin_merge') ? undefined : issueNavigatorPageEntryPoint),
		supportsPreviewPanel: true,
		isHydrateRootEnabled: fg('nin-hydrate-remaining-routes'),
	}),
);
